import React from 'react';
import { useWindowSize } from 'react-use';
import config from '../../website-config';
import { HeaderButtons } from 'components/header';

const FooterButtons = () => {
    const onMap = () => {
        const href = `${config.googlemaps}`;
        const a = document.createElement('a');
        a.href = href;
        a.setAttribute('target', '_blank');
        a.click();
    };
    return (
        <>
            <div className="headerMap">
                <i className="icofont-google-map"></i>
                <a href="#contact" onClick={onMap} className="btn-header animated fadeInUp scrollto">
                    Our location
                </a>
            </div>
        </>
    );
};

const Footer = (): JSX.Element => {
    const { width } = useWindowSize();
    const isMobile = width <= 768;
    const classToUse = isMobile ? 'footerWrapperMobile' : 'footerWrapper';

    if (width < 1540 && !isMobile) {
        return (
            <footer id="footer">
                <div className="footerwrapperlarge">
                    <div className="footerWrapper">
                        {isMobile && <FooterButtons />}
                        <div>
                            <div className="copyright">
                                &copy; Copyright{' '}
                                <strong>
                                    <span>Calvary Paediatrics</span>
                                </strong>
                                . All Rights Reserved
                            </div>
                        </div>
                        <FooterButtons />
                    </div>
                    <div className="footerWrapper">
                        <div />
                        <HeaderButtons />
                    </div>
                </div>
            </footer>
        );
    }

    return (
        <footer id="footer">
            <div className={classToUse}>
                {isMobile && <FooterButtons />}
                <div>
                    <div className="copyright">
                        &copy; Copyright{' '}
                        <strong>
                            <span>Calvary Paediatrics</span>
                        </strong>
                        . All Rights Reserved
                    </div>
                </div>
                {!isMobile && <FooterButtons />}
                {!isMobile && <HeaderButtons />}
            </div>
        </footer>
    );
};

export default Footer;
